import { CheckCircle, ExternalLink, Zap } from "lucide-react";
import { useState } from "react";
import TestApiModal from "./TestApiModal";

export default function ServiceCard({ service, integration, onConfigure }) {
  const [showTestModal, setShowTestModal] = useState(false);

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              <h3 className="text-xl font-bold text-gray-900">
                {service.name}
              </h3>
              {service.status === "Connected" ? (
                <span className="flex items-center gap-1 px-3 py-1 bg-green-600 text-white rounded-md text-xs font-medium">
                  <CheckCircle className="w-3 h-3" />
                  Connected
                </span>
              ) : (
                <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-md text-xs font-medium">
                  Available
                </span>
              )}
            </div>
            <p className="text-gray-600 mb-4">{service.description}</p>
            <div className="flex items-center gap-6 text-sm text-gray-700">
              <span>
                <span className="font-medium">Endpoints:</span>{" "}
                <span className="font-bold">{service.endpoints}</span>
              </span>
              {service.requests >= 0 && (
                <>
                  <span>
                    <span className="font-medium">Requests:</span>{" "}
                    <span className="font-bold">{service.requests}</span>
                  </span>
                  <span>
                    <span className="font-medium">Latency:</span>{" "}
                    <span className="font-bold">{service.latency}</span>
                  </span>
                </>
              )}
            </div>
          </div>
          <div className="flex items-center gap-4 ml-6">
            {/* Read-only toggle - displays status from API */}
            <label className="relative inline-flex items-center cursor-not-allowed">
              <input
                type="checkbox"
                checked={service.enabled}
                disabled
                className="sr-only peer"
              />
              <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600 opacity-75"></div>
            </label>
            <div className="flex flex-col gap-2">
              <button
                onClick={() => onConfigure(service)}
                className="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium"
              >
                Configure
                <ExternalLink className="w-4 h-4" />
              </button>
              <button
                onClick={() => setShowTestModal(true)}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                <Zap className="w-4 h-4" />
                Test API
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Test API Modal */}
      <TestApiModal
        isOpen={showTestModal}
        onClose={() => setShowTestModal(false)}
        service={service}
        integration={integration}
      />
    </>
  );
}
